import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from "axios";
import $ from "jquery";
import JsPDF from "jspdf";
import "jspdf-autotable";
import Papa from "papaparse";
import DataTable from "react-data-table-component";
import { Link, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import SkeletonTicketList from "../../../../loaders/SkeletonTicketList";
import { GetCampusBuildingsList } from '../../../../services/CampusBuildingService';
import { DeleteCampusResousePages, GetCampusPageResourseListCancelToken } from '../../../../services/CampusPagesServer';
import { handleTableScroll } from "../../../../utils/commonFunction";
import { TABLE_ROWS_PER_PAGE } from "../../../../utils/Constants";
import PermissionsGate from "../../../../utils/permissionGate";
import { popupConfirmDeleteWarning } from '../../../../utils/Popups';
import CreateResourses from './CreateResourses';
import { mapBuildingsToSelect } from '../../../../utils/CampusBuildingsUtil';
import Tablefilter from "../../../common/Tablefilter";
import useDebounce from "../../../../hooks/useDebounce";
import { useDebouncedApiEffect } from "../../../../hooks/useDebouncedApiEffect";

function Resouses({ formik, refresh, linkedCampus }) {
  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounce(searchTerm, 500);
  const [updateData, setUpdateData] = useState({});
  const [update, setUpdate] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(10);
  const [page, setPage] = useState(1);
  const [sortField, setSortField] = useState("resourceName");
  const [sortOrder, setSortOrder] = useState("asc");
  const [totalRows, setTotalRows] = useState(0);
  const [campusPagesResourseData, setCampusPagesResourseData] = useState([]);
  const [showCreateResourceModal, setShowCreateResourceModal] = useState(false);
  const { id } = useParams();
  const [filteredResourceList, setFilteredResourceList] = useState([]);
  
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [buildingOptionsLoading, setBuildingOptionsLoading] = useState(false);
  const [buildingFilter, setBuildingFilter] = useState({ arr: [], checkObj: {} });

  useEffect(() => {
    let isMounted = true;
    
    const loadBuildings = async () => {
      const campusId = formik.values.linkedCampus;
      if (!campusId && campusId !== 0) {
        if (isMounted) {
          setBuildingOptions([]);
          setBuildingOptionsLoading(false);
        }
        return;
      }
      
      try {
        if (isMounted) {
          setBuildingOptionsLoading(true);
          setBuildingOptions([]);
        }
        const resBuildingsData = await GetCampusBuildingsList(Number(campusId));
        
        if (!isMounted) return;
        
        const mappedCampusBuildings = mapBuildingsToSelect(resBuildingsData.data?.campusBuildingDetails);
        setBuildingOptions(mappedCampusBuildings);
      } catch (error) {
        if (isMounted) console.error("Error loading buildings", error);
      } finally {
        if (isMounted) setBuildingOptionsLoading(false);
      }
    };
    
    loadBuildings();
    
    return () => { isMounted = false; };
  }, [formik.values.linkedCampus]);

  useEffect(() => {
    $(document).ready(function () {
      $(".dropdown-toggle").click(function () {
        $('.rdt_TableCell').css('z-index', 0);
        $(this).parents('.rdt_TableCell').css('z-index', 22);
      });
    });
  }, []);

  useEffect(() => {
    handleTableScroll();
  }, [loading]);

  const resetFilter = () => {
    setSearchTerm("");
    setBuildingFilter({ arr: [], checkObj: {} });
    setPage(1);
  };

  const handleSort = (column, sortDirection) => {
    setSortField(column.sortField);
    setSortOrder(sortDirection === "asc" ? "asc" : "desc");
    setPage(1);
  };

  const handlePageChange = (pageNo) => {
    setPage(pageNo);
  };

  const handlePerRowsChange = (newPerPage) => {
    setPerPage(newPerPage);
    setPage(1);
  };

  const handleSearchFilter = (e) => {
    setSearchTerm(e.target.value);
    setPage(1);
  };

  const handleClick = (row) => {
    setSelectedData(row);
    setUpdate(true);
  };

  const handleDelete = (id) => {
    popupConfirmDeleteWarning((result) => {
      if (result.isConfirmed) {
        DeleteCampusResousePages(id)
          .then((res) => {
            Swal.fire("Deleted!", "Campus Resource has been deleted.", "success");
            setUpdateData(!updateData);
            const filteredList = formik.values.resource_id?.filter((item) => item.id !== id);
            formik.setFieldValue("resource_id", filteredList);
          })
          .catch((error) => console.error(error));
      }
    });
  };

  const fetchResources = useCallback(async ({ cancelToken }) => {
    if (!formik.values?.id) return;
    setLoading(true);
    try {
      const params = {
        start: (page - 1) * perPage,
        count: perPage,
        sort: sortField,
        order: sortOrder,
        search: debouncedSearch,
        building: buildingFilter.arr.length ? buildingFilter.arr : undefined,
        campusId: formik.values.id
      };
      const res = await GetCampusPageResourseListCancelToken(params, cancelToken);
      const apiResources = res?.data?.data?.data || [];
      setFilteredResourceList(apiResources);
      setTotalRows(res?.data?.range?.total || 0);
      formik.setFieldValue("resource_id", apiResources);
    } catch (error) {
      if (!axios.isCancel(error)) {
        console.error(error);
      }
    } finally {
      setLoading(false);
    }
  }, [formik.values.id, page, perPage, sortField, sortOrder, debouncedSearch, buildingFilter.arr]);

  useDebouncedApiEffect(
    fetchResources,
    [formik.values?.id, refresh, page, perPage, sortField, sortOrder, debouncedSearch, buildingFilter.arr]
  );

  const columns = useMemo(() => [
    {
      name: "Name",
      selector: "resourceName",
      sortField: "resourceName",
      sortable: true,
      cell: (row) => (
        <div>
          <Link
            className="as-text-blue curser feature-name"
            data-toggle="modal" 
            data-target="#updateresource"
            onClick={() => handleClick(row)}
            title={row.resourceName}
          >
            <span className="textLimit100">{row.resourceName}</span>
          </Link>
        </div>
      ),
    },
    {
      name: "Buildings",
      selector: (row) => {
        const buildings = row?.buildings || [];
        return buildings.length ? buildings.map((b) => b.label).join(", ") : "-";
      },
      cell: (row) => {
        const buildings = row?.buildings || [];
        if (!buildings.length) {
          return <span className="text-muted">-</span>;
        }
        return (
          <div className="d-flex flex-wrap align-items-center">
            {buildings.map((building) => (
              <span
                key={building.id}
                className="badge mr-1 mb-1"
                style={{
                  backgroundColor: building.grouping_color || "#28a745",
                  color: "#fff"
                }}
              >
                {building.name}
              </span>
            ))}
          </div>
        );
      },
    },
    {
      name: "Actions",
      selector: "",
      cell: (row) => (
        <div className="assessment-08 btn-dropdown-grp">
          <div className="as-buttons d-flex">
            <button
              type='button'
              className="btn btn-primary h-auto rounded-circle"
              title="Edit Resource"
              data-toggle="modal" 
              data-target="#updateresource"
              onClick={() => handleClick(row)}
            >
              <i className="fal fa-edit"></i>
            </button>

            <button
              type='button'
              className="btn btn-danger rounded-circle"
              onClick={() => handleDelete(row.id)}
            >
              <i className="fal fa-trash-alt"></i>
            </button>
          </div>
        </div>
      ),
    },
  ], []);

  const exportData = (fileType, fileName) => {
    let data = [];
    const header = ["Name", "Buildings"];
    Swal.fire({
      title: "File downloading",
      onOpen: function () {
        Swal.showLoading();
      },
    });

    data = [...filteredResourceList];
    data = data?.map((row) => {
      const buildings = Array.isArray(row?.buildings) ? row.buildings : [];
      const buildingNames = buildings.length ? buildings.map(b => b.name || b.label).join(', ') : "-";
      return {
        Name: row?.resourceName ? row?.resourceName : "-",
        Buildings: buildingNames,
      };
    });

    if (fileType === "csv") {
      const csvString = Papa.unparse({ fields: header, data });
      const blob = new Blob([csvString], {
        type: "text/csv;charset=utf-8,",
      });
      const blobURL = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.download = fileName;
      anchor.href = blobURL;
      anchor.click();
      setTimeout(() => {
        URL.revokeObjectURL(blobURL);
      }, 1000);
      Swal.close();
    } else if (fileType === "xlsx") {
      const compatibleData = data.map((row) => {
        const obj = {};
        header.forEach((col) => {
          obj[col] = row[col];
        });
        return obj;
      });
      let wb = XLSX.utils.book_new();
      let ws1 = XLSX.utils.json_to_sheet(compatibleData, { header });
      XLSX.utils.book_append_sheet(wb, ws1, "Campus Gallery");
      XLSX.writeFile(wb, `${fileName}.xlsx`);
      Swal.close();
      return false;
    }
    if (fileType === "pdf") {
      const compatibleData = data?.map((row) => {
        return [
          row.Name,
          row.Buildings,
        ];
      });
      const doc = new JsPDF();
      doc.autoTable({
        head: [header],
        body: compatibleData,
        styles: {
          minCellHeight: 10,
          minCellWidth: 5,
          halign: "left",
          fontSize: 8,
        },
      });
      doc.save(`${fileName}.pdf`);
      Swal.close();
      return false;
    }
  };

  return (
    <>
      <div className="my-tickets-info-list Tickets-main-wrap mb-4">
        <div className="custom-table-div filter-search-icon card-table-custom program-table">
          <div className="search-filter-div">
            <div className="search-filter-div-left">
              <div className="system-administration-table table-responsive">
                <div className="table-responsive-div">
                  <div id="assessment-table-main_wrapper" className="dataTables_wrapper no-footer">
                    <div id="assessment-table-main_filter" className="dataTables_filter">
                      <label>
                        <input
                          type="search"
                          className=""
                          placeholder="Search"
                          aria-controls="assessment-table-main"
                          onChange={handleSearchFilter}
                          value={searchTerm}
                        />
                      </label>
                      {buildingOptionsLoading ? (
                        <button type="button" className="btn btn-primary" disabled style={{ minWidth: 200, marginLeft: 10 }}>
                          <i className="fas fa-spinner fa-spin"></i> Loading...
                        </button>
                      ) : buildingOptions.length > 0 && (
                        <div className="d-inline-block ml-2" style={{ minWidth: 200 }}>
                          <Tablefilter
                            filterName="Campus Building"
                            optionArr={buildingOptions.map(opt => ({ value: opt.value, label: opt.label }))}
                            state={buildingFilter}
                            setState={setBuildingFilter}
                            stopOptionSorting={true}
                            isOptionReversed={false}
                            isHtmlInRLF={false}
                          />
                        </div>
                      )}
                      <div className="filter-eff filter-data-btn">
                        <button className="filter-buttons">
                          <i className="fal fa-filter"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filter-button-group">
                  <div className="reset-btn-group">
                    <div className="button-reset dropdown-comman">
                      <button
                        className="btn btn-primary"
                        onClick={resetFilter}
                        title="Reset"
                      >
                        <i className="fal fa-redo"></i>Reset
                      </button>
                    </div>
                    <div className="files-export-group">
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("xlsx", "Campus gallery");
                        }}
                        title="Export spreadsheet"
                      >
                        <i className="fal fa-file-excel icon"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("csv", "Campus gallery");
                        }}
                        title="Export CSV"
                      >
                        <i className="fal fa-file-csv icon"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-files"
                        onClick={() => {
                          exportData("pdf", "Campus gallery");
                        }}
                        title="Export PDF"
                      >
                        <i className="fal fa-file-pdf icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="search-filter-div-right">
              <div className="filter-search-bar-blk">
                <div className="add-ticket-blk button-reset dropdown-comman">
                  <PermissionsGate
                    RenderError={() => (
                      <button
                        type="button"
                        className="btn btn-primary"
                        title="Add Resource"
                        disabled={loading ? true : false}
                        data-toggle="modal" data-target="#resource"
                      >
                        <i className="fal fa-plus"></i> Add Resource
                      </button>
                    )}
                    scopes={["sadd"]}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      title="Add Resource"
                      data-toggle="modal" data-target="#resource"
                      onClick={() => setShowCreateResourceModal(true)}
                    >
                      <i className="fal fa-plus"></i> Add Resource
                    </button>
                  </PermissionsGate>
                </div>
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filteredResourceList}
            progressComponent={<SkeletonTicketList />}
            pagination
            paginationServer
            sortServer
            paginationTotalRows={totalRows}
            paginationPerPage={perPage}
            paginationRowsPerPageOptions={TABLE_ROWS_PER_PAGE}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            onSort={handleSort}
            defaultSortField="resourceName"
            defaultSortAsc={true}
            highlightOnHover={false}
            persistTableHead
            noDataComponent={loading ? <SkeletonTicketList /> : "No resources found"}
          />
        </div>
      </div>

      <div
        className="topic-add-modal modal fade"
        id="updateresource"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content modal-border-update">
            <div className="modal-body p-0">
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">
                  <i className="fal fa-edit"></i> Edit Resource
                </h5>
                <button type="button" data-dismiss="modal" className="close" title="Close"><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
              </div>
              <div>
                <CreateResourses
                  campusId={id ? Number(id) : 0}
                  resourceType={'update'}
                  resourceFormik={formik}
                  row={selectedData}
                  setSelectedData={setSelectedData}
                  id={"updateresource"}
                  buildingOptions={buildingOptions}
                  buildingOptionsLoading={buildingOptionsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal fade"
        id="resource"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content modal-border-update">
            <div className="modal-body p-0">
              <div className="modal-header modal-header-custom">
                <h5 className="modal-title">
                  <i className="fal fa-plus"></i> Add Resource
                </h5>
                <button type="button" data-dismiss="modal" className="close" title="Close"><span aria-hidden="true">×</span><span className="sr-only">Close</span></button>
              </div>
              <div>
                <CreateResourses
                  campusId={id ? Number(id) : 0}
                  resourceType={'create'} 
                  resourceFormik={formik} 
                  setSelectedData={setSelectedData} 
                  id={"resource"} 
                  buildingOptions={buildingOptions}
                  buildingOptionsLoading={buildingOptionsLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Resouses;